import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import cx from 'classnames'

import Box from './box'

const Spinner = ({ className, centered }) => {
  const classes = cx(className, 'm-spinner', {
    'm-spinner--centered': centered,
  })

  return (
    <Box className={classes}>
      <CircularProgress />
    </Box>
  )
}

export default Spinner
